<template>
	<field-wrapper v-bind="wrapper" @hook:mounted="watchField">
		<DatePicker
			range
			v-model="model"
			:disabled="disabled"
			:clearable="clearable"
			prefix-class="datepicker"
			value-type="YYYY-MM-DD"
			input-class="datepicker-styled-input"
			popup-class="datepicker-popup"
			format="DD/MM/YYYY"
			range-separator=" 🡒 "
			@hook:mounted="setResetButtonIcon"
		/>
	</field-wrapper>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import FieldWrapper from '@/components/shared/FieldWrapper'
import field from '@/mixins/field'

const RESET_PATH =
	'M257.96 299.121c104.6-118.38 282.101-149.176 422.322-64.923 158.068 94.977 209.289 300.416 114.313 458.483-79.572 132.431-236.679 189.873-378.505 149.163-27.458-7.881-54.34-19.445-79.978-34.85l-33.581 55.888c30.635 18.407 62.762 32.214 95.57 41.632 169.505 48.654 357.28-19.977 452.381-178.252 113.51-188.912 52.293-434.441-136.619-547.951-160.066-96.177-360.777-66.915-487.408 59.197V75.486h-65.2v256.235c0 18.004 14.596 32.6 32.6 32.6H450.09v-65.2H257.96Z'

export default {
	name: 'FieldDateRange',
	props: {
		defaultValue: {
			type: Array,
			default: () => [null, null]
		}
	},
	computed: {
		clearable() {
			return this.model.some((date, i) => date !== this.defaultValue[i])
		}
	},
	methods: {
		setResetButtonIcon() {
			const path = this.$el.querySelector('.datepicker-icon-clear svg path')
			if (path) path.setAttribute('d', RESET_PATH)
		}
	},
	watch: {
		clearable(next) {
			if (next) {
				this.$nextTick(() => this.setResetButtonIcon())
			}
		}
	},
	mixins: [field],
	components: {
		DatePicker,
		FieldWrapper
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
input {
	@extend %field;
}
</style>
